module.exports = __webpack_public_path__ + "email_ico@2x.0c8e86ad1662b3e22a373f07b514aa2e.png";